import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AmericaCoolAuthorize from "./pages/AmericaCoolAuthorize";
import AppSettingsLauncher from "./components/AppSettingsLauncher";
import NativeAppChromeController from "./components/NativeAppChromeController";
import NativePhotoComposer from "./components/NativePhotoComposer";
import NativeFeedMediaEnhancer from "./components/NativeFeedMediaEnhancer";
import NativeProfilePostEnhancer from "./components/NativeProfilePostEnhancer";
import PhotoPostUploadFix from "./components/PhotoPostUploadFix";
import StreamerCheerOnboardingBridge from "./components/StreamerCheerOnboardingBridge";
import "./index.css";
import "./appMobilePolish.css";
import "./appMobilePolishOverrides.css";
import "./profilePostMobileFix.css";
import "./desktopStreamChatFix.css";
import "./iosChatInputFix.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
const isAmericaCoolAuthorize = window.location.pathname === "/integrations/america-cool/authorize";

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {isAmericaCoolAuthorize ? (
        <AmericaCoolAuthorize />
      ) : (
        <>
          <App />
          <AppSettingsLauncher />
          <NativeAppChromeController />
          <NativePhotoComposer />
          <NativeFeedMediaEnhancer />
          <NativeProfilePostEnhancer />
          <PhotoPostUploadFix />
          <StreamerCheerOnboardingBridge />
        </>
      )}
    </BrowserRouter>
  </React.StrictMode>
);
